export enum LEDStateEnum {
    off = 0,
    on = 1,
}
